// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1DPRg","vLegacy":"SelectSecondary_vLegacy__1b5oI","error":"SelectSecondary_error__3ZKFJ","disabled":"SelectSecondary_disabled__376Qc"};